import { formatFieldValue } from 'form/helpers/field_value_formatter';

import FormField from './form_field';

export default class AutocompleteFormField extends FormField {
	_options;

	constructor(fieldProps = {}) {
		super(fieldProps);
	}

	get options() {
		return this._options;
	}

	set options(value) {
		this._options = value;
	}
}
